export const AUTH_NAMESPACE = 'auth';

// mutations
export const SET_TOKEN = 'setToken';
export const SET_AUTH = 'setAuth';
export const SET_RETURN_URL = 'setReturnUrl';

// actions
export const GENERATE_TOKEN_FROM_URL = 'generateTokenFromUrl';
export const LOGIN = 'login';
export const LOGOUT = 'logout';

export default {};
